import { useParams } from "react-router-dom"
import { GrantPost } from "./grant_post"

export const GrantEdit = () => {
    const { id } = useParams() as any
    return <GrantPost id={id} />
}